// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Course section{margin-bottom:3rem}.payment{border-top:1px solid #ccc}.payment .item{border-bottom:1px solid #ccc;padding-top:1rem;padding-bottom:1rem}.Multiplayer{border:1px solid #cbe4f2;margin-bottom:1rem}.Multiplayer .number{display:flex;background-color:#cbe4f2;align-items:center;justify-content:center;width:30px}.Multiplayer .del{padding-top:1rem;padding-right:1rem}", ""]);
// Exports
module.exports = exports;
